import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import Logo1 from '../../assets/img/partners/logo1.png';
import Logo2 from '../../assets/img/partners/logo2.png';
import Logo3 from '../../assets/img/partners/logo3.png';
import Logo4 from '../../assets/img/partners/lal.jpg';
import Logo5 from '../../assets/img/partners/logo5.jpg';
import Logo6 from '../../assets/img/partners/logo6.png';
import Logobirdem from '../../assets/img/partners/birdem.jpeg';
import medinova from '../../assets/img/partners/medinova.jpeg';
import Logo10 from '../../assets/img/partners/logo11.png';
import { AuthContext } from '../../context/AuthContext';

const FALLBACK_LABS = [
  { name: 'Popular', image: Logo1 },
  { name: 'Thyrocare', image: Logo2 },
  { name: 'Ibn Sina', image: Logo3 },
  { name: 'Dr. Lal PathLabs', image: Logo4 },
  { name: 'Islami Bank Hospital', image: Logo5 },
  { name: 'Chevron', image: Logo6 },
  { name: 'DNA Solution', image: Logo10 },
  { name: 'Medinova', image: medinova },
  { name: 'BIRDEM', image: Logobirdem },
];

const Partners = () => {
  const { postActivity } = useContext(AuthContext);
  const [partnerLogos, setPartnerLogos] = useState([]);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/press/banner-get/?banner_type=lab-partner&is_active=true&ordering=sorting&limit=50`
      )
      .then((resp) => {
        if (resp.data?.results && resp.data.results.length > 0) {
          setPartnerLogos(resp.data.results);
        }
      })
      .catch(() => {});
  }, []);

  const displayLabs = partnerLogos && partnerLogos.length > 0 ? partnerLogos : FALLBACK_LABS;

  return (
    <section className='partners'>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <h5 className='section-heading text-center'>Our Lab Partners</h5>
            <p className='text-center main-desc mx-auto'>
              Your tests will be done from our partner labs where quality is
              uncompromised.
            </p>
          </div>
          <div className='col-12'>
            <div className='row logo-sec justify-content-center'>
              {displayLabs.map((item, i) => (
                <div className='col-4 col-md-3 single' key={item.id || i}>
                  <div
                    className='main'
                    onClick={() =>
                      postActivity('banner', 'Lab Partner', window.location.href)
                    }
                  >
                    <img src={item.image} alt={item.name || ''} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
